import { render, staticRenderFns } from "./DatatableBodyChildCell.vue?vue&type=template&id=39cad03c&"
import script from "./DatatableBodyChildCell.vue?vue&type=script&lang=js&"
export * from "./DatatableBodyChildCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports